import { useState, type FormEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import { referralsService } from '@/services/referralsService'
import { useAuthStore } from '@/stores/authStore'
import { PARCEIROS_HOME_PATH } from './parceirosNav'

export function useParceirosLogin() {
  const navigate = useNavigate()
  const login = useAuthStore((s) => s.login)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [code, setCode] = useState('')
  const [step, setStep] = useState<'credentials' | 'otp'>('credentials')
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')
  const [submitting, setSubmitting] = useState(false)

  async function submit(event: FormEvent) {
    event.preventDefault()
    setSubmitting(true)
    setError('')
    try {
      if (step === 'credentials') {
        const resp = await referralsService.login(email, password)
        const payload = resp.data
        if (payload?.user) {
          login(payload.user, payload.token)
          navigate(PARCEIROS_HOME_PATH)
          return
        }
        if (payload?.requiresOtp === false) {
          setError('Não foi possível entrar. Confira e-mail e senha.')
          return
        }
        setStep('otp')
        setMessage('Se o e-mail estiver cadastrado, enviaremos um código.')
        return
      }
      const resp = await referralsService.verifyOtp(email, code)
      const payload = resp.data
      if (payload?.user) {
        login(payload.user, payload.token)
      }
      navigate(PARCEIROS_HOME_PATH)
    } catch {
      setError('Não foi possível entrar. Confira os dados e tente de novo.')
    } finally {
      setSubmitting(false)
    }
  }

  return { email, setEmail, password, setPassword, code, setCode, step, message, error, submitting, submit }
}
